export const Props = () => ({
  //ID поста, к которому относятся комментарии
  postId: {
    type: Number,
    required: true,
  },

  //Отображать упрощенный интерфейс для комментариев?
  basicView: {
    type: Boolean,
    required: false,
    default: false,
  },

  //Контекст вызова комментариев (инфошум / сигналы)
  context:{
    type: String,
    required: false,
    default: 'infonoise',
    validator: (value) => {
      const allowedTypes = ['infonoise', 'signal'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'context' в компоненте CommentsForm может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },

  //Где рендериться список комментариев? (В попапе или на странице)
  commentsPlace: {
    type: String,
    required: true,
    validator: (value) => {
      const allowedTypes = ['popup', 'page'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'commentsPlace' в компоненте CommentList может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  }
});